import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_121: DocMigration = {
  maxSchemaVersion: "0.0.121",
  description: "Separate rake frieze board and eave frieze board.",
  apply(json: any) {
    const { settings: allSettings, roofs, dormers } = json;

    for (const settingsId in allSettings) {
      const settings = allSettings[settingsId];
      if (settings.type !== "ROOF_SETTINGS") {
        continue;
      }

      if (settings.sweepProfile) {
        settings.rakeFriezeBoard = settings.sweepProfile;
        delete settings.sweepProfile;
      }

      settings.eaveFriezeBoard = "NONE";
    }

    for (const roofId in roofs) {
      const roof = roofs[roofId];

      if (roof.includeFriezeBoardOnEaves) {
        roof.eaveFriezeBoard = roof.sweepProfile ?? "TRIM_BOARD_1_6";

        delete roof.includeFriezeBoardOnEaves;
      } else {
        roof.eaveFriezeBoard = "NONE";
      }

      if (roof.sweepProfile) {
        roof.rakeFriezeBoard = roof.sweepProfile;

        delete roof.sweepProfile;
      }
    }

    for (const dormerId in dormers) {
      const dormer = dormers[dormerId];

      if (dormer.sweepProfile) {
        dormer.rakeFriezeBoard = dormer.sweepProfile;
        delete dormer.sweepProfile;
      }

      dormer.eaveFriezeBoard = "NONE";
    }

    return json;
  },
};

export default migration_0_0_121;
